import { render, staticRenderFns } from "./ProductBox.vue?vue&type=template&id=8c32b8c4&"
import script from "./ProductBox.js?vue&type=script&lang=js&"
export * from "./ProductBox.js?vue&type=script&lang=js&"
import style0 from "./ProductBox.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./ProductBox.lang.cs.yaml?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Ftmp%2Fbuild%2Fthemes%2Fcvb%2Fcomponents%2Fproduct%2FProductBox%2FProductBox.vue&lang=yaml"
if (typeof block0 === 'function') block0(component)

export default component.exports